import { ThrowStmt } from "@angular/compiler";
import { Component, Input, OnInit } from "@angular/core";
import { DescriptorLink } from "../../property/descriptor-link.model";
import { Property } from "../../property/property.model";

@Component({
  selector: "app-metadata-details",
  templateUrl: "./metadata-details.component.html",
  styleUrls: ["./metadata-details.component.scss"],
})
export class MetadataDetailsComponent implements OnInit {
  excludeFields = [
    "alternateNamesForFuzzySearch",
    "preferredNameForFuzzySearch",
  ];

  @Input() set properties(value: Property[]) {
    if (value) {
      let details = value.find((x) => x.name === "jsonFieldValues");

      if (details && details.value) {
        this.detailsArray = this.convertPropertiesDetails(details.value);
        this.propertiesReady = true;
      }
    }
  }

  propertiesReady = false;
  detailsArray: any[] = [];
  fieldsOrder = [
    "dateOfBirth",
    "placeOfBirth",
    "dateOfDeath",
    "placeOfDeath",
    "startOfActivity",
    "endOfActivity",
    "gender",
    "associatedLanguage",
    "affiliation",
    "occupation",
    "fieldOfActivity",
    "titleOfPerson",
    "otherDesignation",
    "associatedPlaceCountry",
    "associatedPlaceResidenceOrHeadquarters",
    "associatedPlaceAddress",
    "associatedPlaceOtherPlace",
    "typeOfCorporateBody",
    "corporateEarlierName",
    "corporateLaterName",
    "eventEarlierName",
    "eventLaterName",
    "typeOfJurisdiction",
    "coords",
    "subjectCategory",
    "issn",
    "corporateBroader",
    "corporateNarrower",
    "subjectBroader",
    "subjectNarrower",
    "genreBroader",
    "genreNarrower",
    "geographicalBroader",
    "geographicalNarrower",
    "relatedPerson",
    "relatedCorporateBody",
    "relatedEvent",
    "relatedSubject",
    "relatedGenre",
    "publicGeneralNote",
    "sourceDataFound",
    "sourceDataNotFound",
  ];

  constructor() {}

  ngOnInit() {}

  mapGender(detail: any) {
    let gendersArray = [];

    let gender = detail.value.find(
      (x) => x.name && x.name === "stringValue"
    ).value;

    let dataAssociated = detail.value.find(
      (x) => x.name && x.name === "dataAssociated"
    ).value;

    let genderValue = dataAssociated
      ? gender + " (" + dataAssociated + ")"
      : gender;

    gendersArray.push({
      type: detail.type,
      value: genderValue,
      name: detail.name,
    });

    return {
      type: "array",
      value: gendersArray,
      name: detail.name,
    };
  }

  mapDataAssociated(detail: any) {
    let outputArray = [];

    let preferredName = detail.value.find(
      (x) => x.name && x.name === "preferredName"
    );
    let dataAssociated = detail.value.find(
      (x) => x.name && x.name === "dataAssociated"
    );
    let nlpId = detail.value.find((x) => x.name && x.name === "nlpId");
    let type = detail.value.find((x) => x.name && x.name === "type");

    let otherPlaceValue = dataAssociated.value
      ? preferredName.value + " (" + dataAssociated.value + ")"
      : preferredName.value;

    outputArray.push({
      type: type.value,
      value: otherPlaceValue,
      name: detail.name,
      linkUrl: nlpId && type ? `/${type.value}/${nlpId.value}` : null,
    });

    if (outputArray.length) {
      return {
        type: "array",
        value: outputArray,
        name: detail.name,
      };
    } else {
      return detail;
    }
  }

  mapPreferred(detail: any) {
    let preferredArray = [];

    detail.value.forEach((item) => {
      if (item instanceof Array) {
        let preferredName = item.find(
          (x) => x.name && x.name === "preferredName"
        );
        let nlpId = item.find((x) => x.name && x.name === "nlpId");
        let type = item.find((x) => x.name && x.name === "type");

        if (preferredName) {
          preferredArray.push({
            type: type.value,
            value: preferredName.value,
            name: detail.name,
            linkUrl: nlpId && type ? `/${type.value}/${nlpId.value}` : null,
          });
        }
      } else if (item instanceof DescriptorLink) {
        preferredArray.push({
          type: item.type,
          value: item.value,
          name: "",
          linkUrl: item.id && item.type ? `/${item.type}/${item.id}` : null,
        });
      }
    });

    if (preferredArray.length) {
      return {
        type: "array",
        value: preferredArray,
        name: detail.name,
      };
    } else {
      return detail;
    }
  }

  convertPropertiesDetails(details: any[]) {
    details.sort(
      (a, b) =>
        this.fieldsOrder.indexOf(a.name) - this.fieldsOrder.indexOf(b.name)
    );

    details = details.map((detail) => {
      if (detail.type === "array" || "property" || "descriptor") {
        if (detail.name === "gender") {
          return this.mapGender(detail);
        }

        if (detail.name === "associatedPlaceOtherPlace") {
          return this.mapDataAssociated(detail);
        }

        if (detail.name === "placeOfDeath") {
          return this.mapDataAssociated(detail);
        }

        if (detail.value instanceof Array && detail.value.length > 0) {
          return this.mapPreferred(detail);
        } else {
          return detail;
        }
      } else {
        return detail;
      }
    });

    for (const filterName of this.excludeFields) {
      details = details.filter((item) => item.name != filterName);
    }

    return details;
  }
}
